var _circle, _circle2, _path, _path2, _circle3, _circle4, _circle5, _path3, _path4, _ellipse, _circle6, _rect, _circle7, _rect2, _rect3, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResultsSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 98,
    viewBox: "0 0 131 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4853,
    cy: 44.9032,
    r: 44.9032,
    fill: "#EAF9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.4854,
    cy: 44.9015,
    r: 35.0968,
    fill: "#C7DDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7183 89.1726C59.5956 93.3863 53.8456 96.0014 47.4848 96.0014C39.8925 96.0014 33.1704 92.2756 29.047 86.5527C27.0116 92.0684 21.7075 96.0014 15.4848 96.0014C7.50342 96.0014 1.0332 89.5312 1.0332 81.5498C1.0332 73.5684 7.50342 67.0982 15.4848 67.0982C19.0962 67.0982 22.3983 68.4229 24.9315 70.6129C26.257 59.3331 35.8489 50.582 47.4848 50.582C55.3246 50.582 62.2366 54.5547 66.3175 60.5967C69.7154 57.8823 74.0235 56.2595 78.7106 56.2595C87.3591 56.2595 94.7171 61.7845 97.4476 69.4974C99.5291 68.2995 101.943 67.6143 104.517 67.6143C112.074 67.6143 118.251 73.5194 118.686 80.9668C119.5 80.6759 120.377 80.5175 121.291 80.5175C125.567 80.5175 129.033 83.9837 129.033 88.2595C129.033 92.5352 125.567 96.0014 121.291 96.0014C118.342 96.0014 115.778 94.3523 114.471 91.926C111.909 94.4464 108.395 96.0014 104.517 96.0014C99.7337 96.0014 95.5029 93.6351 92.9315 90.0093C89.3229 93.7062 84.2848 96.0014 78.7106 96.0014C72.7271 96.0014 67.3613 93.3567 63.7183 89.1726Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0332 81.5498C1.0332 73.5684 7.50342 67.0982 15.4848 67.0982C19.0962 67.0982 22.3983 68.4229 24.9315 70.6128C26.257 59.3331 35.8489 50.582 47.4848 50.582C55.3246 50.582 62.2366 54.5547 66.3175 60.5967C69.7154 57.8823 74.0235 56.2595 78.7106 56.2595C87.3591 56.2595 94.7171 61.7845 97.4476 69.4974C99.5291 68.2995 101.943 67.6143 104.517 67.6143C112.074 67.6143 118.251 73.5194 118.686 80.9668C119.5 80.6759 120.377 80.5175 121.291 80.5175C125.567 80.5175 129.033 83.9837 129.033 88.2595",
    stroke: "#05587C",
    strokeWidth: 2.06618,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.3238,
    cy: 26.3218,
    r: 1.54839,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.776,
    cy: 63.4854,
    r: 1.03226,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 55.4827,
    r: 2.32258,
    stroke: "#002D40",
    strokeWidth: 1.54963
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7892 38.7078H36.6457M45.4199 34.255V29.9336",
    stroke: "#05587C",
    strokeWidth: 1.54963,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0918 35.1712L38.6706 31.75",
    stroke: "#05587C",
    strokeWidth: 1.54963,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.7423,
    cy: 93.678,
    rx: 26.0645,
    ry: 2.32258,
    fill: "#ABC0DC"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.1941,
    cy: 53.9362,
    r: 14.7097,
    fill: "#EAF9FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.3594,
    y: 60.2891,
    width: 28.7696,
    height: 10.2965,
    rx: 5.14824,
    transform: "rotate(45 75.3594 60.2891)",
    fill: "#002D40"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.2969,
    cy: 54.5063,
    r: 15.7451,
    transform: "rotate(45 62.2969 54.5063)",
    stroke: "#002D40",
    strokeWidth: 6.06162
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.4047,
    height: 2.13875,
    rx: 1.06937,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 67.4395 58.1494)",
    fill: "#05587C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.4047,
    height: 2.13875,
    rx: 1.06937,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 65.9258 49.376)",
    fill: "#05587C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6569 29.778C60.2914 29.7781 60.806 30.2925 60.806 30.927C60.8058 31.5614 60.2913 32.0759 59.6569 32.0761C59.0225 32.0761 58.508 31.5614 58.5079 30.927C58.5079 30.2924 59.0224 29.778 59.6569 29.778ZM79.6534 37.1515C82.8021 40.3001 84.9185 44.0947 85.9987 48.1096C86.1632 48.722 85.8004 49.3519 85.1881 49.5169C84.5753 49.6817 83.9443 49.3189 83.7794 48.7062C82.8009 45.0697 80.8851 41.6328 78.0286 38.7763C74.0421 34.7899 68.9215 32.6329 63.7049 32.3039C63.072 32.2637 62.5913 31.7181 62.6311 31.0851C62.671 30.4518 63.2173 29.9707 63.8506 30.0107C69.6039 30.3736 75.2565 32.7546 79.6534 37.1515Z",
    fill: "#05587C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4863 67.9375L90.2059 79.657",
    stroke: "white",
    strokeWidth: 2.2998,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsSearch);
export default __webpack_public_path__ + "static/media/noResultsSearch.dbd4af9752881e747229f97e894d633a.svg";
export { ForwardRef as ReactComponent };